/* tslint:disable */
/* eslint-disable */
/**
 * Munchi Dashboard Server Api
 * The Munchi API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @enum {string}
 */

export const PaymentMethod = {
    Cash: 'Cash',
    Card: 'Card',
    Voucher: 'Voucher',
    EPassi: 'EPassi',
    Edenred: 'Edenred',
    Munchi: 'Munchi',
    Flatpay: 'Flatpay',
    GiftUp: 'GiftUp',
    MobilePay: 'MobilePay',
    CardManual: 'CardManual',
    EdenredManual: 'EdenredManual',
    EmployeeDiscount: 'EmployeeDiscount',
    LunchVoucher: 'LunchVoucher',
    EdenredVoucher: 'EdenredVoucher',
    SmartumVoucher: 'SmartumVoucher',
    Invoice: 'Invoice',
    Smartum: 'Smartum',
    GiftCard: 'GiftCard',
    Debit: 'Debit',
    Credit: 'Credit',
    GiftCardManual: 'GiftCardManual',
    WoltBenefit: 'WoltBenefit',
    Fundis: 'Fundis',
    UberEats: 'UberEats',
    MunchiGiftCard: 'MunchiGiftCard',
    WoltManual: 'WoltManual',
    MotoralLaksu: 'MotoralLaksu',
    ResQ: 'ResQ',
    GillAndGill: 'GillAndGill',
    Kiinteisto: 'Kiinteisto',
    JPN: 'JPN',
    NineLives: 'NineLives',
    Trade: 'Trade',
    Exchange: 'Exchange',
    Tilisiirto: 'Tilisiirto',
    LoyaltyPoints: 'LoyaltyPoints',
    DiningByAmex: 'DiningByAmex'
} as const;

export type PaymentMethod = typeof PaymentMethod[keyof typeof PaymentMethod];



